export function canDownloadInvoice(invoice) {
  return !!invoice?.downloadUrl
}

export function openInvoiceDownload(invoice) {
  if (!canDownloadInvoice(invoice)) {
    return false
  }

  window.open(invoice.downloadUrl)
  return true
}
